// extracted by mini-css-extract-plugin
export default {"scale":"style_scale__LzUVx","scale__item":"style_scale__item__7QW9i","fill":"style_fill__JrIyI"};